import { getCanonicalParentToken } from "./addressGeoHierarchy";
import { AddressGeoSelections, AddressGeoToken } from "./types";

export const resolveGeoParentId = (
  token: AddressGeoToken,
  selections: AddressGeoSelections,
): string | undefined => {
  const parentToken = getCanonicalParentToken(token);
  let parentId = parentToken ? selections[parentToken]?.id : undefined;

  if (
    (token === "district" ||
      token === "city" ||
      token === "locality" ||
      token === "street") &&
    selections.subject
  ) {
    parentId = selections.subject.id;
  }

  if (
    (token === "locality" || token === "city" || token === "street") &&
    selections.district
  ) {
    parentId = selections.district.id;
  }

  if (
    (token === "street" || token === "locality" || token === "house") &&
    selections.city
  ) {
    parentId = selections.city.id;
  }

  if ((token === "street" || token === "house") && selections.locality) {
    parentId = selections.locality.id;
  }

  if (token === "house" && selections.street) {
    parentId = selections.street.id;
  }

  return parentId;
};
